<template>
    <layout>
        <template slot="content">
            <div class="home">
                <h3 class="home__title">
                    Главная страница Фестиваль "Благость"
                </h3>

                <el-card
                    v-loading="isLoading"
                    class="home__card"
                    shadow="hover"
                >
                    <template v-if="lastUpcomingEvent">
                        <router-link
                            :to="lastUpcomingEventParticipantsRoute"
                            class="home__event-title home__link"
                        >
                            {{ lastUpcomingEvent.attributes.title }}
                        </router-link>
                    </template>

                    <div
                        v-else-if="!isLoading"
                        class="home__empty"
                    >
                        Будущие фестивали не найдены
                    </div>
                </el-card>
            </div>
        </template>
    </layout>
</template>

<script>
import Layout from '@/views/layouts/Layout';
import breadcrumbs from '@/mixins/breadcrumbs';
import { Event } from '@/api';
import { ROUTES } from '@/enums';

export default {
    name: 'Home',

    components: {
        Layout
    },

    mixins: [
        breadcrumbs
    ],

    data() {
        return {
            isLoading: false,
            lastUpcomingEvent: null
        };
    },

    computed: {
        $breadcrumbs() {
            return [];
        },

        lastUpcomingEventParticipantsRoute() {
            if (!this.lastUpcomingEvent) {
                return null;
            }

            return {
                name: ROUTES.EVENT.CARD.PARTICIPANTS,
                params: {
                    eventId: this.lastUpcomingEvent.attributes.id
                },
                query: {
                    page: 1
                }
            };
        }
    },

    mounted() {
        this._loadLastEvent();
    },

    methods: {
        _loadLastEvent() {
            this.isLoading = true;

            Event.getLastEvent()
                .then(event => {
                    this.lastUpcomingEvent = event;
                })
                .catch(() => {
                    this.lastUpcomingEvent = null;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.home {
    max-width: 900px;

    &__title {
        margin: 0 0 24px;
    }

    &__card {
        max-width: 640px;
    }

    &__event-title {
        display: inline-block;
        margin-bottom: 12px;
        font-size: 18px;
        font-weight: 600;
        line-height: 1.4;
    }

    &__link {
        color: #409eff;
        text-decoration: none;
    }

    &__empty {
        color: #909399;
        font-size: 14px;
        line-height: 1.5;
    }
}
</style>
